import { FC } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import { LEAD_TYPE_LABEL, LeadType } from "views/leads-id/types";

const LEAD_TYPE_BADGE_CLASS: Partial<Record<LeadType, string>> = {
  [LeadType.Owner]: "!bg-info-50 !text-info-700",
  [LeadType.Realtor]: "!bg-success-50 !text-success-800"
};

export const LeadTypeBadge: FC<{ leadType: LeadType }> = ({ leadType }) => (
  <Badge
    variant={BadgeVariant.PRIMARY}
    size={BadgeSize.SM}
    className={LEAD_TYPE_BADGE_CLASS[leadType]}
  >
    {LEAD_TYPE_LABEL[leadType] ?? leadType}
  </Badge>
);
